import * as types from '../actions/types'
import Immutable from 'immutable'
import objectifyArray from 'objectify-array'
import { isPrimitive } from 'util';

const INITIAL_STATE = Immutable.fromJS({
    columns: [],
    ids: [],
    data: [],
    records: 0,
    page: 1,
    take: 200,
    query: '',
    connection: 'mysql'
})

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.ADMINDB_POBLAR_RESULTADOS:
            let data = action.payload.data.data
            const ids = []
            let page = action.payload.page
            let take = state.get('take')
            let skip = take * (page - 1)

            data = data.map((x, n) => {
                x.id3n71f13r = skip + n + 1
                ids.push(x.id3n71f13r)
                return x
            })
            state = state.set('ids', Immutable.fromJS(ids))
            data = objectifyArray(data, {by: 'id3n71f13r'})
            state = state.set('data', Immutable.fromJS(data))
            state = state.set('records', action.payload.data.records)
            state = state.set('page', action.payload.page)
            if (action.payload.data.data.length > 0) {
                let columns = Object.keys(action.payload.data.data[0])
                columns.pop()
                columns = columns.map((x, n) => {
                    let w = action.payload.data.data.reduce((a,b) => {
                        a = (String(b[x]).length > a) ? String(b[x]).length : a
                        return a
                    }, 0)
                    w = (x.length > w) ? x.length : w
                    return {ID:n+1,CAPTION:x,VALUE:x,TYPE:'VARCHAR2',FORMAT:'',WIDTH:(w*6) + 12,FIXED:false}
                })
                columns = [{ID:0,CAPTION:'No',VALUE:'id3n71f13r',TYPE:'VARCHAR2',FORMAT:'',WIDTH:40,FIXED:true},...columns]
                state = state.set('columns', columns)
            }
            return state
        case types.MODIFICAR_INPUTS_ADMINDB:
            if (isPrimitive(action.payload.value)) {
                state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }
            return state
        case types.ADMINDB_RESETEAR_TABLA:
            state = state.set('ids', Immutable.fromJS([]))
            state = state.set('data', Immutable.fromJS({}))
            state = state.set('records', 0)
            state = state.set('columns', Immutable.fromJS([]))
            return state
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/admindb.js